import {
  SET_ADMIN_ALL_SERVICES_TICKETS,
  SET_ADMIN_TICKETS,
  SET_OPERATOR_ALL_SERVICES_TICKETS,
  SET_OPERATOR_TICKETS,
  SET_TICKET_TYPES,
  SET_USER_TICKETS,
} from "../actions/TicketActions";

const initialState = {
  ticketTypes: [],
  userTickets: [],
  operatorTickets: [],
  adminTickets: [],
  operatorAllServicesTickets: [],
  adminAllServicesTickets: [],
};

const TicketReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TICKET_TYPES:
      return {
        ...state,
        ticketTypes: action.payload,
      };

    case SET_USER_TICKETS:
      return {
        ...state,
        userTickets: action.payload,
      };

    case SET_OPERATOR_TICKETS:
      return {
        ...state,
        operatorTickets: action.payload,
      };

    case SET_ADMIN_TICKETS:
      return {
        ...state,
        adminTickets: action.payload,
      };

    case SET_OPERATOR_ALL_SERVICES_TICKETS:
      return {
        ...state,
        operatorAllServicesTickets: action.payload,
      };

    case SET_ADMIN_ALL_SERVICES_TICKETS:
      return {
        ...state,
        adminAllServicesTickets: action.payload,
      };

    default:
      return state;
  }
};

export default TicketReducer;
